module.exports = {"TXTWCL_No_Games_to_Show":{"id":"TXTWCL_No_Games_to_Show","defaultMessage":"Немає ігор для відображення"}}